import { render, staticRenderFns } from "./BrushChart.vue?vue&type=template&id=2ca3a92c"
import script from "./BrushChart.vue?vue&type=script&lang=js"
export * from "./BrushChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports